import Vue from 'vue';

export * from './msw-alerts.store';

export  { default as MswAlertModule } from './msw-alerts.store';

export const updateNotificationCountEventBus = new Vue();
export const UPDATE_NOTIFICATION_COUNT = 'UPDATE_NOTIFICATION_COUNT';
